/* eslint-disable */
import * as registry from '../registry.js'
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Components_Performancetable_Trackeddays2Inputs */

const id_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("id", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}h`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}h`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const ms_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ms", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}h`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}h`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const da_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("da", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}d`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}d`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const de_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("de", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}t`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}t`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const en_us2_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("en-US", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}d`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}d`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const es_es2_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-ES", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} d`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} d`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const es_mx2_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("es-MX", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`Rastreado por ${i?.count} día`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`Rastreado por ${i?.count} días`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const fil_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fil", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} araw`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} araw`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const fr_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}j`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}j`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const it_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("it", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}g`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}g`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const hu_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hu", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}n`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}n`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const nl_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("nl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}d`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}d`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const no_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("no", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}d`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}d`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const pl_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pl", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}d`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}d`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const pt_br2_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt-BR", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}d`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}d`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const pt_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("pt", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}d`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}d`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const ro_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ro", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}z`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}z`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const fi_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("fi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}pv`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}pv`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const sv_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("sv", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}d`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}d`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const vi_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("vi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}n`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}n`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const tr_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("tr", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}g`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}g`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const cs_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("cs", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}d`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}d`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const bg_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("bg", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}д`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}д`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const ru_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ru", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} день`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} дней`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const uk_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("uk", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}д`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}д`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const ar_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ar", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count} يوم`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count} يوم`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const hi_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("hi", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}दि`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}दि`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const th_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("th", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}วัน`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}วัน`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const ja_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ja", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}日`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}日`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const zh_cn2_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-CN", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}天`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}天`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const zh_hant1_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("zh-Hant", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}天`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}天`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

const ko_components_performancetable_trackeddays2 = /** @type {(inputs: Components_Performancetable_Trackeddays2Inputs) => LocalizedString} */ (i) => {const countPlural = registry.plural("ko", i?.count, {});
	if (countPlural === "one") return /** @type {LocalizedString} */ (`${i?.count}일`);
	if (countPlural === "other") return /** @type {LocalizedString} */ (`${i?.count}일`);
	return /** @type {LocalizedString} */ ("components.performanceTable.trackedDays");
};

/**
* | countPlural | output |
* | --- | --- |
* | "one" | "{count}d" |
* | "other" | "{count}d" |
*
* @param {Components_Performancetable_Trackeddays2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const components_performancetable_trackeddays2 = /** @type {((inputs: Components_Performancetable_Trackeddays2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Components_Performancetable_Trackeddays2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_components_performancetable_trackeddays2(inputs)
	if (locale === "ms") return ms_components_performancetable_trackeddays2(inputs)
	if (locale === "da") return da_components_performancetable_trackeddays2(inputs)
	if (locale === "de") return de_components_performancetable_trackeddays2(inputs)
	if (locale === "en-US") return en_us2_components_performancetable_trackeddays2(inputs)
	if (locale === "es-ES") return es_es2_components_performancetable_trackeddays2(inputs)
	if (locale === "es-MX") return es_mx2_components_performancetable_trackeddays2(inputs)
	if (locale === "fil") return fil_components_performancetable_trackeddays2(inputs)
	if (locale === "fr") return fr_components_performancetable_trackeddays2(inputs)
	if (locale === "it") return it_components_performancetable_trackeddays2(inputs)
	if (locale === "hu") return hu_components_performancetable_trackeddays2(inputs)
	if (locale === "nl") return nl_components_performancetable_trackeddays2(inputs)
	if (locale === "no") return no_components_performancetable_trackeddays2(inputs)
	if (locale === "pl") return pl_components_performancetable_trackeddays2(inputs)
	if (locale === "pt-BR") return pt_br2_components_performancetable_trackeddays2(inputs)
	if (locale === "pt") return pt_components_performancetable_trackeddays2(inputs)
	if (locale === "ro") return ro_components_performancetable_trackeddays2(inputs)
	if (locale === "fi") return fi_components_performancetable_trackeddays2(inputs)
	if (locale === "sv") return sv_components_performancetable_trackeddays2(inputs)
	if (locale === "vi") return vi_components_performancetable_trackeddays2(inputs)
	if (locale === "tr") return tr_components_performancetable_trackeddays2(inputs)
	if (locale === "cs") return cs_components_performancetable_trackeddays2(inputs)
	if (locale === "bg") return bg_components_performancetable_trackeddays2(inputs)
	if (locale === "ru") return ru_components_performancetable_trackeddays2(inputs)
	if (locale === "uk") return uk_components_performancetable_trackeddays2(inputs)
	if (locale === "ar") return ar_components_performancetable_trackeddays2(inputs)
	if (locale === "hi") return hi_components_performancetable_trackeddays2(inputs)
	if (locale === "th") return th_components_performancetable_trackeddays2(inputs)
	if (locale === "ja") return ja_components_performancetable_trackeddays2(inputs)
	if (locale === "zh-CN") return zh_cn2_components_performancetable_trackeddays2(inputs)
	if (locale === "zh-Hant") return zh_hant1_components_performancetable_trackeddays2(inputs)
	return ko_components_performancetable_trackeddays2(inputs)
});
export { components_performancetable_trackeddays2 as "components.performanceTable.trackedDays" }